<template>
    <div  @click="dateOff" class="wxSend wxNoscroll sp4">
        <wxBack></wxBack>
        <div class="bgShow"  ref="refContent">
            <Row>
                <Form id="formSp4" ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                            用&nbsp;&nbsp;户&nbsp;&nbsp;名
                        </Col>
                        <Col span="14" offset="2">
                            <FormItem prop="username">
                                <Input type="text" disabled v-model="formInline.realname">
                                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                                </Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                            招待时间
                        </Col>
                        <Col span="14" offset="2">
                            <FormItem prop="meal_date">
                                <DatePicker :options="options3" @on-change="dateOff" readonly @click.native.stop="dateOn" :open="openDate" type="date" placeholder="请选招待餐日期" v-model="formInline.meal_date"></DatePicker>
                            </FormItem>
                        </Col>
                    </Row>
                    <!--{{showIt}}-->
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                            招待餐次
                        </Col>
                        <Col span="14" offset="2">
                            <FormItem class="zdSp2" prop="shiduan">
                                <Select v-model="formInline.meal_type" size="big">
                                    <Option selected v-for="(item,index) in shiduanList" :value="item.key" :key="index">{{ item.value }}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                            用户部门
                        </Col>
                        <Col span="14" offset="2">
                            <Form-item class="zdSp" prop="department">
                            	<el-select style="height: 30px;text-align: center;" class="ivu-select ivu-select-single ivu-select-big" v-model="formInline.department">
								    <el-option
								      v-for="item in departmentList"
								      :key="item.name"
								      :label="item.name"
								      :value="item.name">
								    </el-option>
								  </el-select>
                                <!--<Select v-model="formInline.department">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>-->
                            </Form-item>
                        </Col>
                    </Row>
                    <Row class="mrT50">
                        <Col class="leftName" span="6">
                            招待人数
                        </Col>
                        <Col span="14" offset="2">
                            <FormItem prop="guests_count">
                                <Input @on-blur="isFocus = true;" @on-focus="isFocus = false;" number type="text" v-model="formInline.guests_count"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col class="leftName" span="6">
                            受招待单位
                        </Col>
                        <Col span="14" offset="2">
                            <FormItem >
                                <Input @on-blur="isFocus = true;" @on-focus="isFocus = false;" type="text" v-model="formInline.receive_department"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <!-- <Row class="mrT50">
                        <Col class="leftName" span="6">
                            受招待人
                        </Col>
                        <Col span="14" offset="2">
                            <FormItem prop="receive_name">
                                <Input @on-blur="isFocus = true;" @on-focus="isFocus = false;" type="text" v-model="formInline.receive_name"></Input>
                            </FormItem>
                        </Col>
                    </Row> -->
                    <Row class="mrT50" style="margin-bottom: 50px;">
                        <FormItem style="width: 100%;">
                            <Button style="width: 70%;height: 50px;" type="primary" @click="edit">{{buttonV}}</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Row>
        </div>
        <wxNav></wxNav>
    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import wxBack from "../wxBack"
    import wxNav from "../wxNav"
    export default {
        props: ["wxCode"],
        data () {
          return{
                openDate:false,
          		isFocus:true,
                ruleInline: {
                    receive_department: [
                        { required: true, message: '请填写受招待单位', trigger: 'blur' }
                    ],
                    "guests_count": [
                        { required: true, type: "number", message: '请输入正确格式', trigger: 'blur' }
                    ]
                },
                options3:{
                    disabledDate (date) {
                        var time = new Date().getTime();
                        var star = new Date().getTime() - 1*1000*60*60*24; 
                        var end = new Date().getTime() + 7*1000*60*60*24; 
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                },
                showIt:{},
                formInline: {
                    username: "",
                    realname: '',
                    meal_date: new Date(),
                    meal_type:"breakfast",
                    department:"",
                    receive_name:"",
                    receive_department:"",
                    guests_count : null
                },
                departmentList:[],
                username:"xianrq",
                buttonV:"确定招待",
                islock: "success",
                status:"",
                title: "招待申请",
                shiduanList:[
                    {
                        value : "早餐",
                        key : "breakfast"
                    },
                    {
                        value : "午餐",
                        key : "lunch"
                    },
                    {
                      value : "晚餐",
                      key : "dinner"
                    }
                ]
            }
        },
        components:{
            wxNav,
            wxBack
        },
        computed: {
            ...mapState(["xcxId","xcxUser","xcxReal"]),
        },
        watch:{
        	isFocus(e){
        		if(!e){
        			this.$Message.success("点击页面空白处展示全部信息");
        		}
            },
            "formInline.meal_date":function(e){
                if(e.getTime()-new Date().getTime()>7*1000*60*60*24){
                    this.$Message.error("请选择一个星期之内");
                    this.formInline.meal_date = new Date();
                }
            }
        },
        methods:{
            ...mapMutations(["SET_XCXID","SET_XCXUSER","SET_XCXREAL","SET_LOADING"]),
            dateOn(){
                this.openDate = true;
            },
            dateOff(){
                this.openDate = false;
            },
            //获得部门信息
            getDepartmentList: function() {
                var that = this;
                let params = {};
                params.data = {}
                params.url = '/sys/department/list';
                params.token = "swgykj9527";
                params.success = function(res) {
                  res = res.data;
                  that.departmentList = res.result.result;
                  that.formInline.department = that.departmentList[0].name;
                }
                this.ajaxPostWX(params);
            },
            //获得人员信息
            getPeople(){
                var that = this;
                // let params = {};
                // var that = this;
                // params.data = {
                //     searchValue: {
                //         "xcx_openId": this.wxCode
                //     }
                // };
                // params.url = "/sys/userinfo/list";
                // params.token = "swgykj9527";
                // params.success = function(res) {
                //    that.formInline.username = res.data.result.result[0].username;
                //    that.formInline.realname = res.data.result.result[0].realname;
                //    that.getData();
                // };
                // this.ajaxPostWX(params);
                that.formInline.username = this.xcxUser;
                that.formInline.realname = this.xcxReal;
            },
            edit(){
                var that = this;
                this.$refs.formInline.validate((valid) => {
                    if (valid) {
                        that.formInline.meal_date = that.formInline.meal_date.format("yyyy-MM-dd")
                        let params = {};
                        params.data = that.formInline;
                        params.url = "/sys/mealentertain/new";
                        params.token = "swgykj9527";
//                      that.showIt = params;
                        params.success = function(res) {
                        	if(res.data.code == "0000"){
                                that.$Message.success(res.data.message);
                                that.formInline.guests_count = "";
                                that.formInline.receive_department = "";
                                that.formInline.receive_name = "";
                        	}else{
                        		that.$Message.error(res.data.message);
                        	}
                        };
                        that.ajaxPostWX(params);
                    } else {
                        that.$Message.error('请确保填写正确');
                    }
                });
                
            }
        },
        mounted: function() {
            this.SET_LOADING("yes");
        	var ele = document.getElementsByClassName("el-select__caret")[0];
        	ele.classList.remove("el-select__caret");
        	ele.classList.remove("el-input__icon");
        	ele.classList.remove("el-icon-arrow-up");
        	ele.classList.add("ivu-icon");
        	ele.classList.add("ivu-icon-arrow-down-b");
        	ele.classList.add("ivu-select-arrow");
            this.getPeople();
            this.getDepartmentList();
            if(parseInt(this.formInline.meal_date.format("hh"))>=9 && parseInt(this.formInline.meal_date.format("hh"))<13){
                setTimeout(()=>{
                	this.formInline.meal_type = "lunch"
				},100)
            }else if(parseInt(this.formInline.meal_date.format("hh"))>=13 && this.formInline.meal_date.format("hh-mm")<('18-30')){
                this.formInline.meal_date = new Date(new Date().getTime() + (1000*60*60*24));
            }else if(this.formInline.meal_date.format("hh-mm")>=('18-30')){
                this.formInline.meal_date = new Date(new Date().getTime() + (1000*60*60*24));
				setTimeout(()=>{
                	this.formInline.meal_type = "lunch"
				},100)
            }
        }
    }
</script>

<style lang="scss">
	.el-select-dropdown__item{
		font-size: 12px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover,.el-select-dropdown__item.selected{
	    color: #fff;
    	background: rgba(45,140,240,.9);
	}
    .sp4{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100%;
        .padding50{
        	padding-bottom: 40vh;
        }
        .zdSp{
        	.is-focus{
        		.ivu-select-arrow {
				    transform: rotate(180deg);
				    display: inline-block;
				}
        	}
        	.el-input__inner{
        		font-size: 12px;
        		text-align: center;
        	}
        }
        .zdSp2{
        	.ivu-select-single .ivu-select-selection{
        		height: 40px;
        		font-size: 14px;
        	}
        	.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
        		height: 40px;
        		line-height: 40px;
        	}
        }
        .bgShow{
            padding-top: 6vw;
            font-size: 4vw;
        }
        .mrT50{
            margin-top: 3vw;
        }
        .mrT50{
            margin-top: 3vw;
        }
        .ivu-form-item{
            width: 100%;
        }
        .bgShow{
            background: #fff;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 100%;
            width: 90%;
            margin: 0 auto;
            .leftName{
                line-height: 40px;
                font-size: 4vw;
                text-align: center;
                color: #706767;
            }
            .ivu-date-picker{
                width: 100%;
            }
        }
    }
    .wxSend{
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxEntertain.vue